import React from 'react';
import AnimatedText from 'react-animated-text-content';
import { Col, Container, Row } from 'react-bootstrap';
const Strategy = () => {
  return (
    <Container fluid className='strategy__main__container'>
      <Container>
        <h1 className='strategy__h1 '>
          <AnimatedText
            type='chars' // animate words or chars
            animation={{
              x: '200px',
              y: '-20px',
              scale: 1.1,
              ease: 'ease-in-out',
            }}
            animationType='throw'
            interval={0.06}
            duration={1}
            tag='p'
            className='animated-paragraph'
            includeWhiteSpaces
            threshold={0.1}
            rootMargin='20%'
          >
            THE KUTEE KITTY STRATEGY
          </AnimatedText>
        </h1>
        <Row>
          <Col>
            <p className='plastic__p plastic__p__box'>
              Recycling is the way to go, and large-scale is the way to do it.
              We at Kutee Kitty have a strategy to popularize plastic awareness and drive the
              biggest environmental movement of the decade through non-fungible tokens (NFTs).                                                                       
            </p>
            <p className='plastic__p plastic__p__box'>
              Our unique strategy to achieve large-scale plastic recycling is
              embedded in technology. Technology has fashioned our world into a
              global village, and one of the biggest and growing marketplaces in
              this village is the world of NFTs.
            </p>
            <p className='plastic__p plastic__p__box'>
              NFTs have become increasingly popular in the last two years, and
              we are ready to take advantage of this trend to save our planet.
              We plan to involve the whole of humanity in saving the planet
              through physical assets and NFTs – assets that will be delivered
              to the physical location of the buyer.
            </p>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Strategy;
